"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTopicsCategories = exports.updateSupportedContentTypeSettings = exports.updateCuratedContent = exports.updateCategorySettings = exports.updateCategorySeoSettings = exports.updateCategoryPermissions = exports.updateCategoryDetails = exports.updateCategoryBannerConfig = exports.reorderCategories = exports.moveCategory = exports.getPermissions = exports.getListCategoryContent = exports.getDefaultPermissions = exports.getCuratedTopics = exports.getCategoryOrderTopics = exports.getCategoryData = exports.getCategoriesList = exports.deleteCategory = exports.createCategory = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getCategoryData = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(id) {
    var _yield$axios$get, data;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get('/categoryV2/getCategory', {
              params: {
                id: id
              }
            });

          case 2:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCategoryData(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.getCategoryData = getCategoryData;

var createCategory = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(category) {
    var _yield$axios$post, data;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.post('/categoryV2/createCategory', _objectSpread({}, category));

          case 2:
            _yield$axios$post = _context2.sent;
            data = _yield$axios$post.data;
            return _context2.abrupt("return", data.id);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createCategory(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.createCategory = createCategory;

var updateCategoryDetails = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(id, categoryDetails) {
    var _yield$axios$post2, data;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.post("/categoryV2/updateCategoryDetails", _objectSpread({
              id: id
            }, categoryDetails));

          case 2:
            _yield$axios$post2 = _context3.sent;
            data = _yield$axios$post2.data;
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function updateCategoryDetails(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

exports.updateCategoryDetails = updateCategoryDetails;

var updateCategorySeoSettings = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(id, seoSettings) {
    var _yield$axios$post3, data;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _axios.default.post("/categoryV2/updateCategorySeoSettings", _objectSpread({
              id: id
            }, seoSettings));

          case 2:
            _yield$axios$post3 = _context4.sent;
            data = _yield$axios$post3.data;
            return _context4.abrupt("return", data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function updateCategorySeoSettings(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

exports.updateCategorySeoSettings = updateCategorySeoSettings;

var updateCategorySettings = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(id, settings) {
    var _yield$axios$post4, data;

    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _axios.default.post('/categoryV2/updateCategorySettings', _objectSpread({
              id: id
            }, settings));

          case 2:
            _yield$axios$post4 = _context5.sent;
            data = _yield$axios$post4.data;
            return _context5.abrupt("return", data);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function updateCategorySettings(_x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();

exports.updateCategorySettings = updateCategorySettings;

var updateSupportedContentTypeSettings = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(id, settings) {
    var _yield$axios$post5, data;

    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _axios.default.post('/categoryV2/setSupportedContentTypes', _objectSpread({
              id: id
            }, settings));

          case 2:
            _yield$axios$post5 = _context6.sent;
            data = _yield$axios$post5.data;
            return _context6.abrupt("return", data);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function updateSupportedContentTypeSettings(_x9, _x10) {
    return _ref6.apply(this, arguments);
  };
}();

exports.updateSupportedContentTypeSettings = updateSupportedContentTypeSettings;

var updateCategoryPermissions = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(id, permissions, type, isContainer) {
    var _yield$axios$post6, data;

    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _axios.default.post("/categoryV2/updateCategoryPermissions", _objectSpread({
              id: id,
              type: type,
              isContainer: isContainer
            }, permissions));

          case 2:
            _yield$axios$post6 = _context7.sent;
            data = _yield$axios$post6.data;
            return _context7.abrupt("return", data);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function updateCategoryPermissions(_x11, _x12, _x13, _x14) {
    return _ref7.apply(this, arguments);
  };
}();

exports.updateCategoryPermissions = updateCategoryPermissions;

var deleteCategory = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(id) {
    var _yield$axios$delete, data;

    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _axios.default.delete('/categoryV2/deleteCategory', {
              data: {
                id: id
              }
            });

          case 2:
            _yield$axios$delete = _context8.sent;
            data = _yield$axios$delete.data;
            return _context8.abrupt("return", data);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function deleteCategory(_x15) {
    return _ref8.apply(this, arguments);
  };
}();

exports.deleteCategory = deleteCategory;

var reorderCategories = /*#__PURE__*/function () {
  var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(parentId, order, type) {
    var _yield$axios$post7, data;

    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _axios.default.post('/categoryV2/reorderCategories', {
              parentId: parentId,
              order: order,
              type: type
            });

          case 2:
            _yield$axios$post7 = _context9.sent;
            data = _yield$axios$post7.data;
            return _context9.abrupt("return", data);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function reorderCategories(_x16, _x17, _x18) {
    return _ref9.apply(this, arguments);
  };
}();

exports.reorderCategories = reorderCategories;

var moveCategory = /*#__PURE__*/function () {
  var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(sourceIds, destinationId, isContainer, language) {
    var _yield$axios$post8, data;

    return _regenerator.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _axios.default.post('/categoryV2/moveCategory', {
              sourceIds: sourceIds,
              destinationId: destinationId,
              isContainer: isContainer,
              language: language
            });

          case 2:
            _yield$axios$post8 = _context10.sent;
            data = _yield$axios$post8.data;
            return _context10.abrupt("return", data);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function moveCategory(_x19, _x20, _x21, _x22) {
    return _ref10.apply(this, arguments);
  };
}();

exports.moveCategory = moveCategory;

var getCategoriesList = /*#__PURE__*/function () {
  var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(types, languageCode) {
    var language, _yield$axios$post9, data;

    return _regenerator.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            language = languageCode !== null && languageCode !== void 0 ? languageCode : '';
            _context11.next = 3;
            return _axios.default.post('/categoryV2/getCategoriesTree', {
              types: types,
              language: language
            });

          case 3:
            _yield$axios$post9 = _context11.sent;
            data = _yield$axios$post9.data;
            return _context11.abrupt("return", data);

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function getCategoriesList(_x23, _x24) {
    return _ref11.apply(this, arguments);
  };
}();

exports.getCategoriesList = getCategoriesList;

var getPermissions = /*#__PURE__*/function () {
  var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(id) {
    var _yield$axios$get2, data;

    return _regenerator.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _axios.default.get('/authorizationV2/getResourceRolesActions', {
              params: {
                type: 'category',
                id: id
              }
            });

          case 2:
            _yield$axios$get2 = _context12.sent;
            data = _yield$axios$get2.data;
            return _context12.abrupt("return", data);

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function getPermissions(_x25) {
    return _ref12.apply(this, arguments);
  };
}();

exports.getPermissions = getPermissions;

var getDefaultPermissions = /*#__PURE__*/function () {
  var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13() {
    var _yield$axios$get3, data;

    return _regenerator.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return _axios.default.get('/authorizationV2/getDefaultRolesActions');

          case 2:
            _yield$axios$get3 = _context13.sent;
            data = _yield$axios$get3.data;
            return _context13.abrupt("return", data);

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function getDefaultPermissions() {
    return _ref13.apply(this, arguments);
  };
}();

exports.getDefaultPermissions = getDefaultPermissions;

var updateTopicsCategories = /*#__PURE__*/function () {
  var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(order, categoryId, type) {
    var _yield$axios$post10, data;

    return _regenerator.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return _axios.default.post('/categoryV2/updateTopicsOrder', {
              order: order,
              categoryId: categoryId,
              type: type
            });

          case 2:
            _yield$axios$post10 = _context14.sent;
            data = _yield$axios$post10.data;
            return _context14.abrupt("return", data);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function updateTopicsCategories(_x26, _x27, _x28) {
    return _ref14.apply(this, arguments);
  };
}();

exports.updateTopicsCategories = updateTopicsCategories;

var getListCategoryContent = /*#__PURE__*/function () {
  var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(id, type, pagination) {
    var _yield$axios$post11, data;

    return _regenerator.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return _axios.default.post('/categoryV2/listCategoryContent', {
              categoryId: id,
              type: type,
              pagination: pagination
            });

          case 2:
            _yield$axios$post11 = _context15.sent;
            data = _yield$axios$post11.data;
            return _context15.abrupt("return", data);

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function getListCategoryContent(_x29, _x30, _x31) {
    return _ref15.apply(this, arguments);
  };
}();

exports.getListCategoryContent = getListCategoryContent;

var getCategoryOrderTopics = /*#__PURE__*/function () {
  var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(id) {
    var _yield$axios$post12, data;

    return _regenerator.default.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return _axios.default.post('/categoryV2/listCategoryOrderTopics', {
              categoryId: id
            });

          case 2:
            _yield$axios$post12 = _context16.sent;
            data = _yield$axios$post12.data;
            return _context16.abrupt("return", data);

          case 5:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function getCategoryOrderTopics(_x32) {
    return _ref16.apply(this, arguments);
  };
}();

exports.getCategoryOrderTopics = getCategoryOrderTopics;

var getCuratedTopics = /*#__PURE__*/function () {
  var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(ids) {
    var _yield$axios$post13, data;

    return _regenerator.default.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return _axios.default.post('/categoryV2/getCuratedContent', {
              ids: ids
            });

          case 2:
            _yield$axios$post13 = _context17.sent;
            data = _yield$axios$post13.data;
            return _context17.abrupt("return", data.result);

          case 5:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function getCuratedTopics(_x33) {
    return _ref17.apply(this, arguments);
  };
}();

exports.getCuratedTopics = getCuratedTopics;

var updateCuratedContent = /*#__PURE__*/function () {
  var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(id, curatedContent, curatedContentTitle) {
    var _yield$axios$post14, data;

    return _regenerator.default.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return _axios.default.post('/categoryV2/updateCategoryCuratedContent', {
              id: id,
              curatedContent: curatedContent,
              curatedContentTitle: curatedContentTitle
            });

          case 2:
            _yield$axios$post14 = _context18.sent;
            data = _yield$axios$post14.data;
            return _context18.abrupt("return", data);

          case 5:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function updateCuratedContent(_x34, _x35, _x36) {
    return _ref18.apply(this, arguments);
  };
}();

exports.updateCuratedContent = updateCuratedContent;

var updateCategoryBannerConfig = /*#__PURE__*/function () {
  var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(id, bannerConfig) {
    var _yield$axios$post15, data;

    return _regenerator.default.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return _axios.default.post('/categoryV2/updateCategoryBannerConfig', {
              id: id,
              bannerConfig: bannerConfig
            });

          case 2:
            _yield$axios$post15 = _context19.sent;
            data = _yield$axios$post15.data;
            return _context19.abrupt("return", data);

          case 5:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function updateCategoryBannerConfig(_x37, _x38) {
    return _ref19.apply(this, arguments);
  };
}();

exports.updateCategoryBannerConfig = updateCategoryBannerConfig;